/**
 * FollowUpTabs
 * Navegação entre Follow-ups / Configurações / Histórico (chips no estilo tarefas).
 */
import React from 'react';
import { cn } from '@/lib/utils';
import type { FollowUpTabId } from '../types';

interface FollowUpTabsProps {
    activeTab: FollowUpTabId;
    onChange: (tab: FollowUpTabId) => void;
}

const TABS: Array<{ id: FollowUpTabId; label: string }> = [
    { id: 'followups', label: 'Follow-ups' },
    { id: 'params', label: 'Configurações' },
    { id: 'history', label: 'Histórico' },
];

const FollowUpTabs: React.FC<FollowUpTabsProps> = ({ activeTab, onChange }) => (
    <nav
        className="mb-s4 -mx-s2 flex gap-s2 overflow-x-auto px-s2 pb-s1 md:mx-0 md:flex-wrap md:overflow-visible md:px-0 md:pb-0"
        aria-label="Seções de Follow-up Automático"
        role="tablist"
    >
        {TABS.map((tab) => {
            const isActive = activeTab === tab.id;
            return (
                <button
                    key={tab.id}
                    type="button"
                    role="tab"
                    onClick={() => onChange(tab.id)}
                    aria-selected={isActive}
                    className={cn(
                        'inline-flex h-11 shrink-0 touch-manipulation items-center rounded-full border px-s3 text-sm transition-colors',
                        'md:h-8',
                        isActive
                            ? 'border-primary/40 bg-primary-subtle font-medium text-primary'
                            : 'border-border bg-surface text-secondary hover:border-primary/40 hover:text-primary',
                    )}
                >
                    {tab.label}
                </button>
            );
        })}
    </nav>
);

export default FollowUpTabs;
